import React, { ReactNode, useEffect } from "react";
import AuthHeader from "../../AuthHeader";
import { Layout } from "antd";
import { Outlet, useNavigate } from "react-router-dom";
import { SelfUser } from "redux/features/authSlice";
import { useAppDispatch } from "hooks";
import { getUserIdentity } from "services/authService";
import { ServerError } from "components/shared/errorNotification/errorNotification";

interface Props {
  children?: ReactNode;
}
const PublicLayout: React.FC<Props> = () => {
  const { Content } = Layout;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const onLoad = async () => {
    try {
      const { data } = await getUserIdentity();
      if (data.success) {
        navigate("/dashboard");
        dispatch(SelfUser(data.data));
      }
    } catch {
      ServerError();
    }
  };
  useEffect(() => {
    onLoad();
  }, []);
  return (
    <>
      <div>
        <main className="app">
          <Layout>
            <AuthHeader />
            <Content className="site-layout-background">
              <Outlet />
            </Content>
          </Layout>
        </main>
      </div>
    </>
  );
};

export default PublicLayout;
